import React, { ReactElement, useState } from 'react';
import { Box, Fade, Grow } from '@material-ui/core';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import defaultLocales from 'globals/locales/default';
import FsButton from 'ui-elements/buttons/FsButton';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsPasswordUpdateForm from 'ui-elements/forms/FsPasswordUpdateForm';
import { Question } from './PasswordUpdate.style-elements';

export interface PasswordUpdateObject {
  [name: string]: string;
}

export interface PasswordUpdateProps {
  title: string;
  subTitle?: ReactElement;
  data: PasswordUpdateObject;
}

const PasswordUpdate: React.FC<PasswordUpdateProps> = ({
  title,
  subTitle,
  data,
}) => {
  const rows = Object.entries(data).map(([name, value]) => ({
    name,
    value,
  }));

  const [isChangingPassword, setIsChangingPassword] = useState<boolean>(false);

  return (
    <Fade in timeout={1000}>
      <FsPaper title={title} subTitle={subTitle}>
        {!isChangingPassword && (
          <Grow in={!isChangingPassword} timeout={300}>
            <Box marginBottom={2}>
              <Question>
                {defaultLocales.changeCurrentPasswordQuestion}
              </Question>
              <FsButton
                color="primary"
                variant="contained"
                startIcon={<LockOpenIcon />}
                onClick={() => setIsChangingPassword(true)}
              >
                {defaultLocales.changePassword}
              </FsButton>
            </Box>
          </Grow>
        )}
        {isChangingPassword && (
          <Grow in={isChangingPassword} timeout={300}>
            <Box maxWidth={600}>
              <FsPasswordUpdateForm
                rows={rows}
                onChange={() => setIsChangingPassword(false)}
              />
            </Box>
          </Grow>
        )}
      </FsPaper>
    </Fade>
  );
};

export default PasswordUpdate;
